function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _createSuper(Derived) {
  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (_isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import KZUIComponent from '../base/index';
import { dimensionType } from '../base/types';
import ColorPalette from './color-palette';
import ColorList from './color-list';
import { filterCopy } from '../utils';
import './style.less';

var ColorPicker = /*#__PURE__*/function (_KZUIComponent) {
  _inherits(ColorPicker, _KZUIComponent);

  var _super = _createSuper(ColorPicker);

  function ColorPicker(props) {
    var _this;

    _classCallCheck(this, ColorPicker);

    _this = _super.call(this, props);

    _this.autoBind('handlePaletteChange', 'handleClickList', 'handleBlur');

    _this.state = {
      a: props.a,
      hex: props.hex
    };
    return _this;
  }

  _createClass(ColorPicker, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      document.body.addEventListener('click', this.handleBlur, false);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      document.body.removeEventListener('click', this.handleBlur, false);
    }
  }, {
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps, nextState) {
      return nextProps.hex !== this.props.hex || nextProps.hide !== this.props.hide || nextState.hex !== this.state.hex;
    }
  }, {
    key: "handleBlur",
    value: function handleBlur(e) {
      if (!this.colorPicker.contains(e.target)) {
        if (this.props.onBlur) {
          this.props.onBlur(e);
        }
      }
    }
  }, {
    key: "handlePaletteChange",
    value: function handlePaletteChange(hex, a) {
      if (this.props.onChange) {
        this.props.onChange(hex, a);
      }
    }
  }, {
    key: "handleClickList",
    value: function handleClickList(hex) {
      var a = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 100;
      this.setState({
        hex: hex,
        a: a
      });

      if (this.props.onChange) {
        this.props.onChange(hex, a);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _classNames;

      var clsPrefix = 'kui-color-picker';

      var _this$props = this.props,
          className = _this$props.className,
          style = _this$props.style,
          type = _this$props.type,
          hide = _this$props.hide,
          recommendColors = _this$props.recommendColors,
          recommendThemeColors = _this$props.recommendThemeColors,
          dimensions = _this$props.dimensions,
          others = _objectWithoutProperties(_this$props, ["className", "style", "type", "hide", "recommendColors", "recommendThemeColors", "dimensions"]);

      var cls = classNames(clsPrefix, (_classNames = {}, _defineProperty(_classNames, "".concat(clsPrefix, "-cpe-simple"), type === 'simple'), _defineProperty(_classNames, "".concat(clsPrefix, "-hide"), hide), _classNames), className);

      var colorPickerStyle = _objectSpread({}, dimensions, {}, style);

      var extraProps = filterCopy(others, 'recentColors');
      var mainJSX;

      if (this.props.type === 'simple') {
        mainJSX = /*#__PURE__*/React.createElement("div", {
          className: "".concat(clsPrefix, "-cpr-container ").concat(clsPrefix, "-cpr-simple")
        }, /*#__PURE__*/React.createElement("div", {
          className: "".concat(clsPrefix, "-title")
        }, "\u989C\u8272\u63A8\u8350"), /*#__PURE__*/React.createElement(ColorList, {
          onChange: this.handleClickList,
          list: recommendColors,
          type: "simple"
        }), /*#__PURE__*/React.createElement("div", {
          className: "".concat(clsPrefix, "-title")
        }, "\u989C\u8272\u81EA\u5B9A\u4E49"), /*#__PURE__*/React.createElement(ColorPalette, {
          hex: this.state.hex,
          a: this.state.a,
          onChange: this.handlePaletteChange,
          type: "simple"
        }));
      } else {
        mainJSX = /*#__PURE__*/React.createElement("div", {
          className: "".concat(clsPrefix, "-cpr-container ").concat(clsPrefix, "-cpr-full")
        }, /*#__PURE__*/React.createElement(ColorPalette, {
          hex: this.state.hex,
          a: this.state.a,
          onChange: this.handlePaletteChange,
          type: "full"
        }), /*#__PURE__*/React.createElement(ColorList, {
          list: recommendThemeColors,
          onChange: this.handleClickList,
          title: "\u4E3B\u9898\u63A8\u8350\u8272",
          type: "full"
        }), /*#__PURE__*/React.createElement(ColorList, {
          list: this.props.recentColors,
          onChange: this.handleClickList,
          title: "\u6700\u8FD1\u4F7F\u7528\u8272",
          type: "full"
        }));
      }

      return /*#__PURE__*/React.createElement("div", _extends({}, extraProps, {
        style: colorPickerStyle,
        className: cls,
        ref: this.storeRef('colorPicker')
      }), mainJSX);
    }
  }]);

  return ColorPicker;
}(KZUIComponent);

ColorPicker.defaultProps = {
  type: 'simple',
  hex: '#ff0000',
  a: 100,
  onChange: null,
  onBlur: null,
  recommendColors: ['#d2000d', '#f7a700', '#f9e900', '#8c5725', '#7bd500', '#3f7600', '#bf00e3', '#9100ff', '#468ee5', '#47e4c2', '#b7eb81', '#000', '#4a4a4a', '#9b9b9b', '#c5c5c5', '#fff'],
  recommendThemeColors: ['blank', '#d2000d', '#f7a700', '#f9e900', '#8c5725', '#7bd500', '#3f7600', '#bf00e3', '#9100ff', 'blank', '#468ee5', '#47e4c2', '#b7eb81', '#000', '#4a4a4a', '#9b9b9b', '#c5c5c5', '#fff'],
  recentColors: ['#d2000d', '#f7a700', '#f9e900', '#8c5725', '#7bd500', '#3f7600', '#bf00e3']
};
ColorPicker.propTypes = {
  type: PropTypes.oneOf(['simple', 'full']),
  hex: PropTypes.string,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  dimensions: dimensionType,
  recommendColors: PropTypes.arrayOf(PropTypes.string),
  recommendThemeColors: PropTypes.arrayOf(PropTypes.string),
  recentColors: PropTypes.arrayOf(PropTypes.string)
};
export default ColorPicker;